import type { ToolUIPart } from 'ai';

import { GeneratedFilesList } from './process-files-tool';

interface ToolInvocationPart {
  type: string;
  state?: string;
  toolCallId?: string;
  output?: {
    generatedFileUuids?: string[];
  };
}

interface FillSl2FormToolProps {
  part: ToolUIPart;
}

/**
 * Component for rendering fillSl2Form tool output.
 */
export function FillSl2FormTool({ part }: FillSl2FormToolProps) {
  if (part.state === 'output-available' && (part as ToolInvocationPart).output) {
    const output = (part as ToolInvocationPart).output!;
    if (output.generatedFileUuids) {
      return (
        <GeneratedFilesList
          files={output.generatedFileUuids.map((uuid, idx) => ({ uuid, filename: `SL2 form ${idx + 1}.pdf` }))}
        />
      );
    }
  }

  return null;
}
